<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div class="container">
      <a class="navbar-brand" href="#"><img src="assets/img/ecobiotec.png" width="55" height="40" class="d-inline-block align-top" alt="">
        Ecobiotec</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#">Home
              <span class="sr-only">(current)</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="">Products</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">About us</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Contact us</a>
          </li>
          <li>
            <app-cart-summary></app-cart-summary>
          </li>
        </ul>
      </div>
    </div>
   
  </nav> -->
<!-- Sidebar -->
<!-- <nav class="navbar navbar-expand-md  bg-dark navbar-dark justify-content-end" >
 
  <a class="navbar-brand"  id="logo">
    <img src="assets/img/logo.png" alt="Logo"  style="width:100px;">
  </a>
  
  <button class="navbar-toggler " type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
    <span class="navbar-toggler-icon "></span>
  </button>

  
  <div class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav" >
      <li class="nav-item ">
        <a class="nav-link" style="color: white;" href="/home">Inicio</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" style="color: white;" href="/home/conocenos">Conocenos</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" style="color: white;" href="/home/contacto">Contacto</a>
      </li>
    </ul>
  </div>

  
</nav>  -->

<!-- 
<nav class="navbar fixed-top d-inline-block align-top navbar-expand-md  bg-dark navbar-dark justify-content-end">
  
  <a class="navbar-brand "  href="" id="logo">
    <img class="d-inline-block align-top" src="assets/img/logo.png" alt="Logo"  style="width:100px;">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
      <span class="navbar-toggler-icon"></span>
  </button>
  <div class="navbar-collapse collapse " id="collapsingNavbar">
      <ul class="navbar-nav" id="text">
          <li class="nav-item active">
              <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="//codeply.com">Codeply</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="#myAlert" data-toggle="collapse">Link</a>
          </li>
      </ul>
      <ul class="navbar-nav ml-auto">
          <li class="nav-item">
              <a class="nav-link" href="" data-target="#myModal" data-toggle="modal">About</a>
          </li>
      </ul>
  </div>
</nav>  -->

<!-- example 2 - using auto margins -->
<nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top"  id="text">
  <div class="navbar-collapse collapse w-100 order-1 order-md-0 dual-collapse2">
      <ul class="navbar-nav mr-auto"  style="font-size:1rem;">
          <li class="nav-item active">
              <a class="nav-link" href="/home">Home</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="/home/conocenos">¿Qué es vizsio?</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="/home/contacto">Contacto</a>
          </li>
         <!--  <li class="nav-item">
              <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="#">Link</a>
          </li> -->
      </ul>
  </div>
  <div class="mx-auto order-0">
      <a class="navbar-brand mx-auto" href="/home"><img src="assets/img/logo.png" alt="Logo"  style="width:100px;"></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".dual-collapse2">
          <span class="navbar-toggler-icon"></span>
      </button>
  </div>
  <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
      <ul class="navbar-nav ml-auto" style="font-size:1rem;">
          <li class="nav-item">
              <a class="nav-link"  href="https://www.facebook.com/VizsioMX"><i class="fab fa-facebook fa-lg" style="font-size: 30px;"></i></a>
          </li>
          <li class="nav-item">
              <a class="nav-link" href="https://www.instagram.com/vizsiomx"><i class="fab fa-instagram fa-lg" style="font-size: 30px;"></i></a>
          </li>
      </ul>
  </div>
</nav>

<div id="espacio"></div>





<!-- </nav>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
<a href="#" class="navbar-brand mx-auto" id="logo">
  <img src="assets/img/logo.png" alt="Logo"  style="width:100px;">
</a>
<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
<span class="navbar-toggler-icon"></span>
</button>
<div class="collapse navbar-collapse justify-content-end nav-justified" id="navbarNav">
<div class="navbar-nav">
<a class="nav-item nav-link active" href="#">Link 1<span class="sr-only">(current)</span></a>
<a class="nav-item nav-link" href="#">Link 2</a>
<a class="nav-item nav-link" href="#">Link 3</a>
</div>
</div>
</nav> -->





<!-- <nav class="navbar navbar-expand-md bg-dark navbar-dark">
 
  <a class="navbar-brand" href="#">Navbar</a>

  
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
    <span class="navbar-toggler-icon"></span>
  </button>

 
  <div class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>
    </ul>
  </div>
</nav> 
 -->

